// SimpleLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

const SimpleLayout = () => {
  return (
    <div>
      {/* Optional: Add common layout elements here, like header or footer */}

      {/* Render the matched nested route component */}
      <Outlet />
    </div>
  );
};

export default SimpleLayout;
